import React from 'react';
import { useTranslation } from 'react-i18next';

import HomeInstantAnalyzer from '../components/HomePage/sections/HomeInstantAnalyzer';
import MarketingPageShell from '../components/marketing/MarketingPageShell';

interface ResumeCheckPageProps {
  onNavigate?: (view: string) => void;
}

const ResumeCheckPage: React.FC<ResumeCheckPageProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <MarketingPageShell
      onNavigate={onNavigate}
      activeView="resume-check"
      title={t('pages.resumeCheck.seoTitle', 'How Good Is Your Resume? | Free ATS Check | GoGrabJob')}
      description={t(
        'pages.resumeCheck.seoDescription',
        'Upload your resume and optionally paste a job description — get instant ATS and match scores, no signup required.',
      )}
      canonical="https://www.gograbjob.com/resume-check"
    >
      <HomeInstantAnalyzer onNavigate={onNavigate} variant="section" />
    </MarketingPageShell>
  );
};

export default ResumeCheckPage;
